import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

const fileName = 'PostWithCredService';

@Injectable({
  providedIn: 'root'
})
export class PostWithCredService {
  loginAuthHeader = new HttpHeaders({
    'Content-Type': 'application/vnd.pingidentity.checkUsernamePassword+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  });

  constructor(
    private utils: UtilService,
    private exceptionTracking: ExceptionTrackingService
  ) {}

  async postWithCredentials(
    authConfig: OauthAEMConfig,
    flowIdValue: string | undefined,
    userInputFields?: ILoginUserNamePasswordInput
  ): Promise<LoginAuthWithCredentials> {
    let requestPayload: PostWithCredentials = {};
    let loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams;
    try {
      let userNamePingFlow: string | undefined = '';

      if (userInputFields?.lastName) {
        userNamePingFlow = `${userInputFields?.userName}${userInputFields?.lastName}`;
      } else {
        userNamePingFlow = userInputFields?.userName;
      }

      requestPayload = {
        username: userNamePingFlow,
        password: userInputFields?.password
      };
      loginAuthWithCredentialsParams = {
        oauthConfig: authConfig,
        flowId: flowIdValue
      };
      return await this.utils.loginAuthWithCredResponse(
        loginAuthWithCredentialsParams,
        requestPayload,
        this.loginAuthHeader
      );
    } catch (exception) {
      const exceptionMetadata: IExceptionMetadata = {
        fileName,
        methodName: 'postWithCredentials',
        exceptionCategory: EXCEPTION_CATEGORY_ENUM.JS_CATCH_BLOCK,
        exceptionMessage: 'Exception caught while calling PostWithCredService'
      };
      const exceptionStr = exception as string;
      this.exceptionTracking.track(exceptionStr, exceptionMetadata);
      return exception as LoginAuthWithCredentials;
    }
  }
}
